<template>
  <div class="parent-element">
    <signature-component />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import SignatureComponent from "@/components/Signature/SignatureComponent.vue";

@Options({
  components: {
    SignatureComponent,
  },
})
export default class SignatureView extends Vue {}
</script>

<style lang="css">
.parent-element {
  overflow: hidden;
}
</style>
